<template>
  <div class="courses">
    <div class="container">
      <div class="filter-area card-shadow">
        <div>
          <el-input class="input-with-select" v-model="keyword" placeholder="请输入课程名称">
            <el-button slot="append" @click="getCourses">搜索</el-button>
          </el-input>
        </div>
        <typeFilter
          name="分 类"
          wholeTypeName="全部"
          :types="orgs"
          :defaultType="0"
          @type-change="handleTypeChange"
        />
      </div>
      <div class="course-list card-shadow" v-loading="loading">
        <div
          class="course-item can-click"
          :class="{ 'first': index === 0 }"
          v-for="(item, index) in courses"
          :key="index"
          @click="viewCourse(item)"
        >
          <el-image class="cover" fit="cover" :src="item.logopic"></el-image>
          <div class="course-info">
            <h1 class="name">{{ item.courseName }}</h1>
            <div class="school">
              <i class="iconfont iconyuanxiao"></i>
              {{ item.orgName }}
            </div>
            <div class="introduction pc">
              <span class="introduction-title">内容简介：</span>
              <span>{{ replaceTag(item.description) }}</span>
            </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>

        <div class="empty-tip" v-if="courses.length === 0">-暂无数据-</div>
      </div>
    </div>
  </div>
</template>

<script>
import typeFilter from "../components/typeFilter.vue";
import { courseTypes, unionCourses } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "courses",
  data() {
    return {
      orgs: [],
      keyword: "",
      currentType: null,
      currentPage: 1,
      pageSize: 12,
      total: 0,
      courses: [],
      loading: false
    };
  },
  created() {
    courseTypes({ leagueId: 12 })
      .then(res => {
        // 返回数据
        for (let i = 0; i < res.list.length; i++) {
          let item = res.list[i];
          item.id = item.subjectId;
          item.name = item.subjectName;
        }
        this.orgs = res.list;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
    this.getCourses();
  },
  methods: {
    getCourses() {
      this.loading = true;
      unionCourses({
        leagueId: 12,
        keyword: this.keyword,
        classfiyid: this.currentType,
        ps: this.pageSize,
        pn: this.currentPage
      })
        .then(res => {
          // 返回数据
          this.courses = res.list;
          this.total = res.total;

          this.loading = false;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
          this.loading = false;
        });
    },
    handleTypeChange(val) {
      this.currentType = val === 0 ? null : val;
      this.getCourses();
    },
    handleCurrentChange() {
      this.getCourses();
    },
    viewCourse(item) {
      window.open(
        `https://www.ulearning.cn/ulearning_web/web!courseDetail.do?courseID=${item.courseId}`
      );
    },
    replaceTag: util.replaceTag
  },
  components: {
    typeFilter
  }
};
</script>

<style scoped>
.filter-area,
.course-list {
  background-color: #fff;
  border: 1px solid #eee;
}

.filter-area {
  margin-top: 30px;
  padding: 20px 20px 8px;
}

.input-with-select {
  margin-bottom: 20px;
  width: 500px;
}

.course-list {
  margin-top: 20px;
  margin-bottom: 80px;
  padding: 0 20px 24px 20px;
}

.empty-tip {
  padding-top: 24px;
}

.course-item {
  position: relative;
  padding: 24px 0;
  border-top: 1px solid #eee;
}

.course-item.first {
  border: unset;
}

.course-item .cover {
  position: absolute;
  width: 200px;
  height: 112.5px;
  background-color: #eee;
}

.course-item .course-info {
  min-height: 112.5px;
  padding-left: 220px;
}

.course-item h1 {
  font-size: 16px;
  height: 22px;
  line-height: 22px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.course-item .school {
  margin-top: 12px;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
}

.school .iconfont {
  margin-right: 8px;
  font-size: 14px;
}

.course-item .introduction {
  margin-top: 10px;
  font-size: 12px;
  height: 48px;
  line-height: 24px;
  overflow: hidden;
}

.course-item .introduction-title {
  color: #969696;
}

@media (max-width: 767px) {
  .filter-area,
  .course-list {
    background-color: unset;
    border: unset;
  }

  .filter-area {
    margin-top: 0;
    padding: 0;
  }

  .input-with-select {
    margin-top: 10px;
    margin-bottom: 15px;
    width: 100%;
  }

  .course-list {
    margin-top: 0;
    margin-bottom: 30px;
    padding: 0;
  }

  .course-item {
    padding: 15px 0;
  }

  .course-item .cover {
    width: 120px;
    height: 67.5px;
  }

  .course-item .course-info {
    min-height: 67.5px;
    padding-left: 134px;
  }

  .course-item h1 {
    font-size: 14px;
    height: 40px;
    line-height: 20px;
    white-space: unset;
    text-overflow: unset;
  }

  .course-item .school {
    margin-top: 10px;
    font-size: 12px;
    height: 16px;
    line-height: 16px;
    color: #888;
    overflow: hidden;
  }

  .school .iconfont {
    font-size: 12px;
  }
}
</style>
